export default __webpack_public_path__ + "static/media/splash-animation.f71c1d4f.gif";